<template>
	<label class="label">
		<v-text-field
			background-color="white"
			hide-details
			:label="label"
			placeholder="__/__/___"
			v-bind="$attrs"
			v-mask="mask"
			:value="picker"
			@input="onInput"
			@change="onChange($event, 'change')"
		></v-text-field>
	</label>
</template>

<script>
import format from 'date-fns/format';

function splitDate(date) {
	return date.split('/');
}

function formatDate(date) {
	if (!date) {
		return null;
	}
	const [day, month, year] = splitDate(date);
	return `${year}-${month}-${day}`;
}

function onChange($event, eventName) {
	const value = formatDate($event);
	if (value) {
		this.$emit(eventName, value);
	} else {
		this.$emit(eventName, null);
	}
}

function onInput($event) {
	this.$emit('input', $event);
	const dateValues = splitDate($event);
	if (dateValues && dateValues.length === 3) {
		this.$emit('format-date', format(new Date(dateValues[2], dateValues[1] - 1, dateValues[0]), this.format));
	} else if (dateValues && dateValues.length < 3) {
		this.$emit('format-date', null);
	}
}

export default {
	name: 'app-date-mask',
	inheritAttrs: false,
	model: {
		prop: 'picker',
		event: 'input',
	},
	props: {
		format: {
			default: 'YYYY-MM-DD',
			type: String,
		},
		label: {
			default: '',
			type: String,
		},
		mask: {
			default: '##/##/####',
			type: String,
		},
		picker: {
			default: null,
		},
	},
	methods: {
		onChange,
		onInput,
	},
};
</script>

<style lang="scss" scoped>
.label {
	font-size: size(small);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/app-date-mask.vue